import React from 'react';
import { Link } from 'react-router';
import { LazyImg } from 'src/hooks/useLazyLoad';
import { ProductItemBySku } from 'src/types/global-types';
import { getPercentage } from 'src/helpers/getPercentage';
import { Price } from 'src/components/Helpers/Price';
import { useVatCausesRender } from 'src/components/AppShell/VatProvider';
import classnames from 'classnames';
import { VatInfo } from 'src/components/VatInfo/VatInfo';
import { Svg } from 'src/components/Svg/Svg';

import classes from './SimpleProductList.scss';

type Props = {
    product: ProductItemBySku;
    simpleProduct?: boolean;
};

export const Product: React.FC<Props> = ({ product, simpleProduct = false }) => {
    const { vat } = useVatCausesRender();
    const currentColor = null;

    const brandBadge = product.brandBadge || { label: '' };

    const brandName = brandBadge && product.brandBadge?.label;
    const productName = product.name.toLowerCase().includes(brandBadge.label.toLowerCase())
        ? product.name.toLowerCase().replace(brandBadge.label.toLowerCase(), '')
        : product.name;

    const showDiscountPrice = Boolean(
        Number(product.previousPrices?.priceExl) > 0 && Number(product.previousPrices?.priceInc) > 0,
    );

    const standardPrice =
        product.marginTierPrices.length > 0
            ? product.marginTierPrices.find((price) => price.quantity === 1) || product.marginTierPrices[0]
            : {
                  price: Number(product.priceRange?.minimumPrice.regularPriceExclFormatted) || 0,
                  priceIncl: Number(product.priceRange?.minimumPrice.regularPriceFormatted) || 0,
              };

    return (
        <div
            className={classnames(classes.product, {
                [classes.simpleProduct]: simpleProduct,
            })}
        >
            <Link to={!currentColor ? `/${product.urlKey}` : `/${product.urlKey}?color=${null}`}>
                <div className={classes.image}>
                    {product.canCustomise && (
                        <>
                            <div className={classes.addYourLogo}>
                                <LazyImg
                                    src={require(
                                        `../../../static/img/${simpleProduct ? 'addYourLogo.png' : 'addIcon.svg'}`,
                                    )}
                                    alt="Add your logo"
                                    className={classes.productListIcon}
                                />
                            </div>
                            {product?.bestseller && (
                                <small className={classes.productListBestseller}>
                                    <Svg name="star" /> Bestseller
                                </small>
                            )}
                        </>
                    )}
                    {showDiscountPrice && standardPrice && (
                        <div className={classes.discount}>
                            {`-${Math.abs(
                                getPercentage(Number(product.previousPrices?.priceExl) || 0, standardPrice.price),
                            )}%`}
                        </div>
                    )}
                    <div
                        style={{
                            backgroundImage: `url(${product.smallImage.url})`,
                        }}
                        className={classes.productImage}
                    />
                </div>

                <div className={classes.info}>
                    {brandName && <p className={classes.brand}>{brandName}</p>}
                    {/* React 19 rejects nested <a> inside <a> (invalid HTML / DOM nesting). */}
                    <p className={classes.title}>{productName}</p>
                    <div className={classes.prices}>
                        {standardPrice && (
                            <>
                                {!showDiscountPrice && product.marginTierPrices.length > 1 && <span>From </span>}
                                <b
                                    className={classnames(classes.standardPrice, {
                                        [classes.crossedOutPrice]: showDiscountPrice,
                                    })}
                                >
                                    <Price
                                        price={
                                            showDiscountPrice ? product.previousPrices?.priceExl : standardPrice.price
                                        }
                                        priceIncl={
                                            showDiscountPrice
                                                ? product.previousPrices?.priceInc
                                                : standardPrice.priceIncl
                                        }
                                        vat={vat}
                                    />
                                </b>
                                {showDiscountPrice ? (
                                    <div className={classes.productListSpecialPrice}>
                                        <b>
                                            <Price
                                                price={standardPrice.price}
                                                priceIncl={standardPrice.priceIncl}
                                                vat={vat}
                                            />
                                        </b>
                                        <VatInfo />
                                    </div>
                                ) : (
                                    <VatInfo />
                                )}
                            </>
                        )}
                    </div>
                </div>
            </Link>
            {/* {treatment === 'on' && (
                <div className={classes.productPickerContainer}>
                    <ProductListColourPicker productId={product.id} onChange={setCurrentColor} />
                    {productCategoriesExist && productCategoryId && (
                        <RenderUpsellTags id={productCategoryId} product={product} className={classes.tagsContainer} />
                    )}
                </div>
            )} */}
        </div>
    );
};
